// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"3d5552a4ba849c8656bc","3180":"4985b56fbd36fd45c85e","9277":"ff727f26f70fda5cc01c"}[chunkId] + ".css";
};